import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import PlanForm from '@galo-monitor/web-containers/forms/company/PlanForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const PlanModal = (props) => {
  const {
    id,
    open,
    handleClose,
    plan,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    err => {
      setLoading(false)
      createDialog({
        id: 'error-plan',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'male',
            action: toLower(t(isEmpty(plan) ? 'register' : 'update')),
            this: toLower(t('plan', { howMany: 1 }))
          })  }.`,
          message: t(err?.response?.data?.message || 'unexpected error occurred')
        }
      })
    },
    [createDialog, plan, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ `${ t('register of {this}', { this: t('plan', { howMany: 1 }) }) } Farm` }
      maxWidth="md"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <PlanForm
        ref={ formRef }
        plan={ plan }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

PlanModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  plan: PropTypes.object
}

PlanModal.defaultProps = {
  plan: {}
}

export default PlanModal
